<template>
  <v-row class="only-print">
    <v-col class="d-flex flex-column align-center justify-center">
      <h2>{{ event.title }} - {{ event.subtitle }}</h2>
      <h3>{{ event.configuration?.mapping?.local?.name }}</h3>
      <h3>{{ event.dates.start }}</h3>
    </v-col>
  </v-row>
</template>

<script lang="ts" setup>
import Event from '@/types/Event'

interface Props {
  event: Event
}

const { event } = defineProps<Props>()
</script>
